//import { host_service } from './environment.prod';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const host_service = {
  host: "http://localhost:8080/ema-admin/v1/ema-system/",//No se usa
  hostAutorize: " https://i0p5sxuvv4.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/ema-authorization/v1/",
  hostEmaCustomers: "https://y5fsn8zc4l.execute-api.us-east-2.amazonaws.com/",
  hostEmaAdmin: "https://i60kxd3lbl.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin2: " https://ygnbfl0t98.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin3: "https://st10ywpjjb.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin4: "https://sp5dxjzvt1.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin5: "https://a64i1d5dwa.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostSecurity: "https://mebgjnr8zg.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostSecurityCustomers: "https://0xd5lqab4h.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/customers/",
  hostEmaCustomersprod: "https://36efcd4oxc.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostSysne: "https://f4db6744sa.execute-api.us-east-2.amazonaws.com/prd/sysne-api/v1/",
  host_victor8: "https://y5fsn8zc4l.execute-api.us-east-2.amazonaws.com",//"Creo que es esta API getCustomersYearRange"
  hostEmaApp: "https://jq691w3neb.execute-api.us-east-2.amazonaws.com/emaadmin-api/v1",
  hostSynePrd: "https://h12bys4bti.execute-api.us-east-2.amazonaws.com/prd/sysne-admin/v1",
  admin: "administration/",
  host_victor4: "https://4hnxs21ph7.execute-api.us-east-2.amazonaws.com", //quitar
  basePath: "/ema-admin/v1",
  hostSysneAdmin: "https://h12bys4bti.execute-api.us-east-2.amazonaws.com/prd/sysne-admin/v1",
  hostSysneAdmin2: "https://i2xyxb0xw0.execute-api.us-east-2.amazonaws.com/prd/sysne-admin/v1",
  monitoring: "https://gbrms8qvph.execute-api.us-east-2.amazonaws.com/production/monitoring-api/v1"
};
export const environment = {
  production: true,
  ambiente: "prod-file",
  descrpcion_ambiente: "",
  version_app: "V2.0.0",
  api: {
    //NO SE USAN PERO ESTAN EN FUNCIONES

    userCustomers:
      host_service.host_victor4 + host_service.basePath + "/customers/users", //quitar

    refreshToken: host_service.host + "both/ema-admin/refresh-token",
    readQuotationGroupService:
      host_service.host + "customers/quotation-v1/group-services/",
    get_customer_data: host_service.host + "customers/",
    get_wo_employees: host_service.host + "contract/work-orders/employees",
    get_associated_service:
      host_service.host + "contract/catalogs/associated-services-types",
    create_schedulle_eventual_service:
      host_service.host +
      "customers/contract/service-scheduling/eventual-service",
    addContractGroupServices:
      host_service.host + "customers/contract/group-services/", /////NO se utilizará
    get_contract_status:
      host_service.host + "customers/contract/general-data/status",
    getCatalogActivitiesElements:
      host_service.host + "contract/services/elements-v1/", /////NO se utilizará
    getCatalogActivitiesGroup: host_service.host + "catalog/activities-group",

    employeesGet: host_service.host + "v1/employees/",
    quotationStatusGet: host_service.host + "catalogs/quotations-status", /////NO se utilizará
    getIndustries: host_service.host + "ema-admin/catalogs/industries", /////NO se utilizará
    prospectosPorCategoria: host_service.host + "v1/ema-admin/prospects",
    //////
    login_LF_V1: host_service.hostAutorize + "token",
    refreshTokenAuto: host_service.hostAutorize + "resfreshtoken",
    validateToken: host_service.hostAutorize + "validationtoken",
    menu_LF_V1: host_service.hostSecurity + "menu",
    logout_v1: host_service.hostAutorize + "logout/",
    notificationsNewPassword:
      host_service.hostEmaCustomers + "send/notifications-new-password",
    tokenTemp: host_service.hostAutorize + "tokenTemp",
    inactiveUser: host_service.hostAutorize + "inactive/user",
    //App
    service_report: host_service.hostEmaApp + "/service-reports",
    work_order_sup: host_service.hostEmaApp + "/work-orders",
    updateWorkOrderSUp: host_service.hostEmaApp + "/work-orders",
    workOrder: host_service.hostEmaApp + "/work-orders",
    devices_monitoring_get:
      host_service.hostEmaApp + "/service-report/monitoring-devices",
    devices_monitoring_upsert:
      host_service.hostEmaApp + "/serviceReport/monitoring-devices",

    //catalogs.yml
    email_attachment_service: host_service.hostEmaAdmin + "send/email",
    get_catalogs_LF_V1: host_service.hostEmaAdmin + "ema-general/catalogs-v1",
    getCountries_LF_V1: host_service.hostEmaAdmin + "catalogs/countries",
    getStates_LF_V1: host_service.hostEmaAdmin + "catalogs/states",
    getCities_LF_V1: host_service.hostEmaAdmin + "catalogs/cities",
    material_chemical: host_service.hostEmaAdmin + "materials-chemical",
    activitiesConfiguration:
      host_service.hostEmaAdmin + "services/activities/configuration",
    sendWhatsApp: host_service.hostEmaAdmin + "send/whats-app-message",
    getZones: host_service.hostEmaAdmin + "catalogs/zones",
    getRoutes: host_service.hostEmaAdmin + "catalogs/routes",
    get_catalogs_LF_V2: host_service.hostEmaAdmin + "ema-general/catalogs-v2",
    catalogPhoto: host_service.hostEmaAdmin + "ema-general/catalogs-v1/photo",
    //customers.yml
    client_service: host_service.hostEmaAdmin + "customers",
    customers_LF_V1: host_service.hostEmaAdmin + "customers", //Probable eliminacion
    getBranchesByCustomerID_LF_V1:
      host_service.hostEmaAdmin + "customers-branches", //Probable eliminacion
    branches_client_service: host_service.hostEmaAdmin + "customers-branches",
    branches_client_all: host_service.hostEmaAdmin + "customers-branches/all",
    eventualID: host_service.hostEmaAdmin + "customers/eventual",
    branches_contacts: host_service.hostEmaAdmin + "customers-branches/contacts",

    //company.yml
    company: host_service.hostEmaAdmin + "company",
    companyBranches: host_service.hostEmaAdmin + "company/branches",
    //vomrntstio
    //contract.yml
    getContractActivitiesElementsV1_LF_V1:
      host_service.hostEmaAdmin + "contract/services/elements-v1/",
    readactivitiesConfiguration:
      host_service.hostEmaAdmin + "contract/services/activities/configuration",
    getContractList_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/general-data", //Cambiar solo por contract
    upsertContract_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/general-data", //Posible Eliminacion
    contract_ind: host_service.hostEmaAdmin + "customers/contract/individual",
    getContractBranches_LF_V1:
      host_service.hostEmaAdmin + "customer-branches/contract/", //CambiarNombre
    add_customer_branches_contract_LF_V1:
      host_service.hostEmaAdmin + "customer-branches/contract", //Posible Eliminacion
    getContractGroupServices_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/group-services", //Cambiar nombre
    deleteContractGroupServices_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/group-services/", //Posible
    add_group_services_Lambda_V1:
      host_service.hostEmaAdmin + "customers/contract/group-services", //Posible
    updateGroup_service:
      host_service.hostEmaAdmin + "customers/contract/update/group-services",
    get_activity_to_contract_LF_V1:
      host_service.hostEmaAdmin + "contract/services-v1/activities", //Cambiar
    add_activity_to_contract_LF_V1:
      host_service.hostEmaAdmin + "contract/services-v1/activities", //Posible
    delete_activity_to_contract_LF_V1:
      host_service.hostEmaAdmin + "contract/services-v1/activities", //Posible
    getassociated_service_by_group_service_LF_V1:
      host_service.hostEmaAdmin + "contract/associated-services/", //Cambiar
    upsert_contract_associated_service_LF_V1:
      host_service.hostEmaAdmin + "contract/associated-services", //Posible
    deleteAssocService:
      host_service.hostEmaAdmin + "contract/associated-services/", //posible
    get_supervisor_and_technical_list_LF_V1:
      host_service.hostEmaAdmin + "employees/data", //cambiar
    get_service_scheduling_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/service-scheduling", //Cambiar
    create_schedulle_LF_V1:
      host_service.hostEmaAdmin + "customers/contract/service-scheduling", //Posible
    file_maps_service: host_service.hostEmaAdmin + "customers/contract/maps",
    servicesDetail:
      host_service.hostEmaAdmin +
      "customers/contract/service-scheduling/detail",
    payment_form_contract: host_service.hostEmaAdmin + "contract/payment-form",
    get_g_s_for_sociated_service_LF_V1:
      host_service.hostEmaAdmin +
      "customers/contract/group-services-associated-service/",
    contract_collections:
      host_service.hostEmaAdmin + "customers/contract/collection-date",

    //devicesAdmin.yml
    devices_service: host_service.hostEmaAdmin2 + "devices",
    updateDevice: host_service.hostEmaAdmin2 + "devices/update", //Posible
    deviceMonitoring: host_service.hostEmaAdmin2 + "device-monitoring",
    deviceManagement: host_service.hostEmaAdmin2 + "device-management",

    //employees.yml
    Employees_LAMBDA_V1: host_service.hostEmaAdmin2 + "employees",
    driverLicenses: host_service.hostEmaAdmin2 + "drivers",
    documentEmployees: host_service.hostEmaAdmin2 + "employees/documents",
    upseremployee: host_service.hostEmaAdmin2 + "employees",
    //employees2.yml
    employeesContacts: host_service.hostEmaAdmin4 + "employees/contacts",
    employeesMedical: host_service.hostEmaAdmin4 + "employees/medical",
    incidents: host_service.hostEmaAdmin4 + "employees/incidents",
    //work_tools
    work_tools: host_service.hostEmaAdmin4 + "equipment",

    //prospects.yml
    prospectosPorCategoria_LF_V1: host_service.hostEmaAdmin2 + "prospects",
    prospectToClient: host_service.hostEmaAdmin2 + "prospect-client",
    prospections_services: host_service.hostEmaAdmin2 + "prospections",
    prospection_letter_service:
      host_service.hostEmaAdmin2 + "prospections/letter",
    prospection_meeting_service:
      host_service.hostEmaAdmin2 + "prospections/meeting",
    //prospects2.yml
    prospoections_view: host_service.hostEmaAdmin4 + "prospections/view",


    //quotations.yml
    getQuotationListByProspectID_LF_V1:
      host_service.hostEmaAdmin2 + "quotations/", //Cambiar
    quotationCreation_LF_V1: host_service.hostEmaAdmin2 + "quotations-upsert",
    deleteQuotation_LF_V1: host_service.hostEmaAdmin2 + "quotations", //posible
    getQuotationByFilter: host_service.hostEmaAdmin2 + "quotationsbyfilter",
    Quotation_Devices_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/devices",
    QuotationGroupService_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/group-services",
    QuotationHasServicePlace_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "quotation/service-places",
    QuotationHasSalesTypes_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "quotation/sales-type",
    Quotation_Credit_Days_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "quotation/credit-days",
    Quotation_Payment_Form_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "quotation/payment-form",
    Quotation_Service_Frecuency_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "quotation/service-frequency",
    QuotationActivities_LAMBDA_V1:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/activities",
    quotationprospectToClient:
      host_service.hostEmaAdmin2 + "quotation/prospect-client",
    quotationHasPest:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/pest",
    quotationHasRequirements:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/requirement",
    quotationHasSpecialTreatments:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/special-treat",
    quotationHasAreas:
      host_service.hostEmaAdmin2 + "customers/quotation-v1/areas",
    QuotationProspectClientInfo:
      host_service.hostEmaAdmin2 + "quotation/prospect/client/info/",
    //quotations2.yml
    quotationHasServiceCoverage: host_service.hostEmaAdmin5 + "quotation/service-coverage",
    getQuotationForContract: host_service.hostEmaAdmin5 + "quotations/contract/",




    //work-order.yml
    GetTechnical_LF_V1: host_service.hostEmaAdmin3 + "work-order/tecnical",
    get_wo_employees_data_LF_V1:
      host_service.hostEmaAdmin3 + "work-orders/employees",
    post_wo_employees_data_LF_V1:
      host_service.hostEmaAdmin3 + "work-orders/employees", //Posible
    create_schedulle_individual_service_LF_V1:
      host_service.hostEmaAdmin3 +
      "customers/contract/individual-work-order-schedulling",
    delete_wo_employees_data_LF_V1:
      host_service.hostEmaAdmin3 + "work-order-employee",
    deleteWorkOrder: host_service.hostEmaAdmin3 + "work-order",
    checkStatusWorkOrder: host_service.hostEmaAdmin3 + "work-order/status",
    workOrdersInformation: host_service.hostEmaAdmin3 + "collections/schedule",
    workOrderBilled: host_service.hostEmaAdmin3 + "work-order/billed",
    eventualServicesForBranch:
      host_service.hostEmaAdmin3 + "work-orders/eventual/branch",
    eventualServices: host_service.hostEmaAdmin3 + "work-orders/eventual",
    workOrderreport: host_service.hostEmaAdmin3 + "work-order/report/",
    inspectionService: host_service.hostEmaAdmin3 + "service-report/inspection",
    workOrderCalendar: host_service.hostEmaAdmin3 + "work-orders/calendar",
    viewWOReport: host_service.hostEmaAdmin3 + "view/work_order/reports", //quitar
    wo_has_employees_v1: host_service.hostEmaAdmin3 + "work-order/employees/v1",
    updateWorkOrderReprogram: host_service.hostEmaAdmin3 + "workorders",



    //sales-doc.yml
    salesDocumentHasServices: host_service.hostEmaAdmin3 + "sales-doc/services",
    salesDocument: host_service.hostEmaAdmin3 + "sales-doc",
    collections: host_service.hostEmaAdmin3 + "sales-doc",

    //service-area.yml
    areas_service: host_service.hostEmaAdmin3 + "service/area",

    //collection-schedull.yml
    collectionSchedule: host_service.hostEmaAdmin4 + "collection/schedull",

    //vehicles.yml
    driversVehicles: host_service.hostEmaAdmin4 + "drivers/vehicles",
    vehiclesAdmin: host_service.hostEmaAdmin4 + "vehicles/get",
    driversVehiclesPolicies: host_service.hostEmaAdmin4 + "drivers/environmental",
    driversVehiclesInsurance: host_service.hostEmaAdmin4 + "drivers/insurances",
    driversVehiclesHealtAndSafety: host_service.hostEmaAdmin4 + "drivers/healtsafety",
    driversHealtAndSafetyKit: host_service.hostEmaAdmin4 + "healtsafety",
    vehicleService: host_service.hostEmaAdmin4 + "vehicles/services",
    vehicleMileageReports: host_service.hostEmaAdmin4 + "vehicles/mileage/view",
    vehicleFuelReports: host_service.hostEmaAdmin4 + "vehicles/fuel/view",
    DRIVERVehicleServiceChedule: host_service.hostEmaAdmin5 + "drivers/services/schedule",
    employessNoWorking: host_service.hostEmaAdmin5 + "vehicles/employees/working",
    //vehicles2
    isEmployeeHasVehicle: host_service.hostEmaAdmin5 + "employee/vehicle",
    isEmployeeHasOppenedWorkingDay:
      host_service.hostEmaAdmin5 + "employee/vehicle/working-day",
    notificationEmployeeHasOppenedWorkingDay:
      host_service.hostEmaAdmin5 + "employee/vehicle/notification",
    unassignVehicleForEmployee:
      host_service.hostEmaAdmin5 + "employee/vehicle/unassign",
    assignVehicleForEmployee:
      host_service.hostEmaAdmin5 + "employee/vehicle/assign",

    //formats.yml
    formats: host_service.hostEmaAdmin4 + "formats",
    businesPorpuse: host_service.hostEmaAdmin4 + "business/porpuse",



    //security

    //users.yml
    user_service: host_service.hostSecurity + "user",
    UserAdmin: host_service.hostSecurity + host_service.admin + "user",
    UserRolesAdmin:
      host_service.hostSecurity + host_service.admin + "user/roles",
    checkUserInformation: host_service.hostSecurity + "user/exist",
    system_config_user_service: host_service.hostSecurity + "user",
    employeeUserData: host_service.hostSecurity + "employee/user",
    pagesConfigurationData: host_service.hostSecurity + "users/permissions",
    applicationPages: host_service.hostSecurity + "application/pages",
    applicationPages1: host_service.hostSecurity + "application/pages",
    //roles.yml
    RolesAdmin: host_service.hostSecurity + host_service.admin + "roles",
    RolesPagesAdmin:
      host_service.hostSecurity + host_service.admin + "roles/pages",
    RolesLabelsAdmin:
      host_service.hostSecurity + host_service.admin + "roles/labels",
    system_config_roles_service:
      host_service.hostSecurity + "administration/roles",
    system_config_roles_labels_service:
      host_service.hostSecurity + "administration/roles/labels",
    system_config_roles_pages_service:
      host_service.hostSecurity + "administration/roles/pages",

    //pages.yml
    PagesAdmin: host_service.hostSecurity + host_service.admin + "pages",
    PagesLabelsAdmin:
      host_service.hostSecurity + host_service.admin + "pages/labels",
    system_config_pages_service:
      host_service.hostSecurity + "administration/pages",
    system_config_pages_labels_service:
      host_service.hostSecurity + "administration/pages/labels",
    ModulesAdmin: host_service.hostSecurity + host_service.admin + "/modules",
    //temp-url.yml
    tempUrl: host_service.hostSecurity + "temp-url",

    //Companies.yml
    companySecurity: host_service.hostSecurity + "/security/company",
    system_config_companies_service: host_service.hostSecurity + "companies",
    system_config_comany_branches_service:
      host_service.hostSecurity + "companies/branch",
    bucketapi: host_service.hostSecurity + "bucket",
    //security-emaCustomers
    //form-control.yml
    formControlService: host_service.hostSecurityCustomers + "form_control/id",
    formControlPageOptionsService:
      host_service.hostSecurityCustomers + "form_control_page_options",

    //languages.yml
    languagesService: host_service.hostSecurityCustomers + "languages",

    //modules.yml
    modulesService: host_service.hostSecurityCustomers + "modules",

    //pages.yml
    pagesLabelsService: host_service.hostSecurityCustomers + "pages_labels",
    pagesOptionsLabelsService:
      host_service.hostSecurityCustomers + "page_options_labels",
    pagesOptionsService: host_service.hostSecurityCustomers + "page_options",
    pagesService: host_service.hostSecurityCustomers + "pages_pages",

    //roles.yml
    rolesPagesService: host_service.hostSecurityCustomers + "roles_pages",
    rolesService: host_service.hostSecurityCustomers + "roles",
    rolesLabelsService: host_service.hostSecurityCustomers + "roles_labels",

    //custo.yml

    DMM_documents: host_service.hostEmaCustomersprod + "customers/doc",
    DMM_document_status: host_service.hostEmaCustomersprod + "update-doc",


    userRolesLabelsCusto: host_service.host_victor4 + host_service.basePath + "/customers/user/roles",
    companyCustomers: host_service.host_victor4 + host_service.basePath + "/customers/company",
    MDUsersCustomers: host_service.host_victor4 + host_service.basePath + "/customers/md_users/",
    DMM_active_user_information:
      host_service.hostSecurityCustomers +

      "users/view",



    //IA
    nubiIA: "https://vv794efg6a.execute-api.us-east-2.amazonaws.com/ema-admin/v1/emaIA",

    ///EMACUSTOMERS "SYNE"
    DMM_operative_folder: host_service.hostSysne + "folder/accept",
    DMM_customers_data: host_service.hostSysne + "customers",
    DMM_customer_branches_data: host_service.hostSysne + "customers/branches",
    DMM_year_configuration: host_service.host_victor8 + "/customers/year",
    DMM_path_list: host_service.hostSysne + "folder",
    DMM_document_list_customer: host_service.hostSysne + "document/data/view",


    ///TRX APIS
    trxCustomers: host_service.hostSysneAdmin + "/trx/customers",
    trxProspectQuotations: host_service.hostSysneAdmin + "/trx/prospect-quotations",
    trxBranches: host_service.hostSysneAdmin + "/trx/customers/branch",
    trxMeeting: host_service.hostSysneAdmin + "/trx/meeting",



    whatsAppHistoryApi:
      "https://vv794efg6a.execute-api.us-east-2.amazonaws.com/ema-admin/v1/whats",
    trxAssociatedService:
      host_service.hostSysneAdmin + "/trx/associated-service",
    trxAssociatedServiceAndActivities:
      host_service.hostSysneAdmin + "/trx/associated-service/config",
    trxAddActvtyToAssociatedService:
      host_service.hostSysneAdmin + "/trx/associated-service/activity",
    trxDeleteAssociatedService:
      host_service.hostSysneAdmin + "/trx/associated-service/",
    createScheduleAS: host_service.hostSysneAdmin + "/trx/work-order/schedule",
    addServicesFromQuotationtoAS:
      host_service.hostSysneAdmin + "/trx/associated-service/quotation",
    employeeTrx: host_service.hostSysneAdmin + "/employee",
    reportContractAct: host_service.hostSysneAdmin + "/report",
    validateMeeatingCheckList: host_service.hostSysneAdmin + "/validate-meeting",
    eventualServiceTrx: host_service.hostSysneAdmin + "/trx/eventual-service",
    workOrderv1: host_service.hostSysneAdmin + "/work-orders",
    workOrderv1AllData: host_service.hostSysneAdmin + "/work-orders/web",
    viewWOReportAService: host_service.hostSysneAdmin + "/associated/reports",
    AssociatedServiceValidation: host_service.hostSysneAdmin + "/associated-service/",
    devicesBatch: host_service.hostSysneAdmin + "/devices/batch",
    devicesConfiguration: host_service.hostSysneAdmin + "/device/config",
    quotationDeviceHasMaterials:
      host_service.hostSysneAdmin + "/quotation/device/material",
    contractDevicesHasMaterials:
      host_service.hostSysneAdmin + "/contrac/device/material",
    additionalCosts:
      host_service.hostSysneAdmin + "/work-order/additional/cost",
    collCollections:
      host_service.hostSysneAdmin + "/coll-collections",
    quotationDevicesBranch: host_service.hostSysneAdmin + "/quotation/device/branch",
    authorizers: host_service.hostSysneAdmin + "/auth/authorizers",
    authDocument: host_service.hostSysneAdmin + "/auth/document",
    collCollectionsVersion: host_service.hostSysneAdmin2 + "/collections/version",
    meetingEmployees: host_service.hostSysneAdmin2 + "/meeting/employees",
    customerFile: host_service.hostSysneAdmin2 + "/customer/branch/document/",
    prospectBranches: host_service.hostSysneAdmin2 + "/prospect/branches",
    prospectBranchesLocations: host_service.hostSysneAdmin2 + "/prospect/branches/locations",
    customerBranchesLocations: host_service.hostSysneAdmin2 + "/customer/branch/locations",


    customerNewClient: host_service.hostSysneAdmin2 + "/customer/new-client",
    customerFiscal: host_service.hostSysneAdmin2 + "/customer/branch/fiscal",
    customerPayment: host_service.hostSysneAdmin2 + "/customer/branch/payment",
    customerContacts: host_service.hostSysneAdmin2 + "/customer/branch/contacts",
    monitoringLog: host_service.monitoring,
    deleteScheduling: host_service.hostSysneAdmin2 + "/del-scheduling",
    monitorCheck: host_service.hostSysneAdmin2 + "/sys/monitor/config",
    clientOperativeFolder: host_service.hostSysneAdmin2 + "/customer/branch/operative/folder",
    newCompVersion: host_service.hostSysneAdmin2 + "/new/component/version",
    prospectionHistory: host_service.hostSysneAdmin2 + "/quotation/history",

    prospoections_view_by_id:
      host_service.hostSysneAdmin2 + "/view-prospections",

    copyQuotation: host_service.hostSysneAdmin2 + "/quotations",
    quotationView: host_service.hostSysneAdmin2 + "/quotation/view",
    quotationGroupServiceHasBranch: host_service.hostSysneAdmin2 + "/group/service/branch",
    customerBranchesFullData: host_service.hostSysneAdmin2 + "/branches/view",

  },
};

export const conts = {
  bukcet: {
    NAME: "aion-ema-admin",
    ENDPOINT: "d2s4.or4.idrivee2-60.com",
  }
}
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
